import {LazyLoadImage, trackWindowScroll} from "react-lazy-load-image-component";
import React, {memo} from "react";

const prepareImageData = (images) => {
    let principalImageInfos = images.find(item => item.code === 'principal_image')
    let imagePrincipal = principalImageInfos ? principalImageInfos : images.length > 0 ? images[0] : null;
    let ambianceImageInfos = images.find(item => item.code === 'ambiance_image')
    let imageAmbiance = ambianceImageInfos ? ambianceImageInfos : imagePrincipal;
    return {
        'imagePrincipal': {
            'src': imagePrincipal?.url.length > 0 ? imagePrincipal.url : 'https://image.but.fr/is/image/but/produit-niv3/NoVisu_Ok',
            'className': '',
            'title': imagePrincipal?.title?.length > 0 ? imagePrincipal.title : '',
            'alt': imagePrincipal?.alt?.length > 0 ? imagePrincipal.alt : 'Visuel disponible prochainement',
            'width': '260',
            'height': '230',

        },
        'imageAmbiance': {
            'src': imageAmbiance?.url.length > 0 ? imageAmbiance.url : 'https://image.but.fr/is/image/but/produit-niv3/NoVisu_Ok',
            'className': 'product-hover',
            'title': imageAmbiance?.title?.length > 0 ? imageAmbiance.title : '',
            'alt': imageAmbiance?.alt?.length > 0 ? imageAmbiance.alt : 'Visuel disponible prochainement',
            'width': '260',
            'height': '230',

        }
    }

}

const WithLazyLoadProductImage = memo((props) => {
    const productImagesData = prepareImageData(props.images)
    const {imagePrincipal, imageAmbiance} = productImagesData;
    return (
        <LazyLoadImage
            className={props.isHovering ? imageAmbiance.className : imagePrincipal.className}
            alt={props.isHovering ? imageAmbiance.alt : imagePrincipal.alt}
            src={props.isHovering ? imageAmbiance.src.replace('produit-niv3', 'produit-list') : imagePrincipal.src.replace('produit-niv3', 'produit-list')}
            scrollPosition={props.scrollPosition}
        />);

})
export const  ProductImage = memo((props) => {
    const productImagesData = prepareImageData(props.images)
    const {imagePrincipal, imageAmbiance} = productImagesData;
    return (
        <img className={props.isHovering ? imageAmbiance.className : imagePrincipal.className}
             fetchpriority="high"
             alt={props.isHovering ? imageAmbiance.alt : imagePrincipal.alt}
             src={props.isHovering ? imageAmbiance.src.replace('produit-niv3', 'produit-list') : imagePrincipal.src.replace('produit-niv3', 'produit-list')}
        />

    )
})
export default trackWindowScroll(WithLazyLoadProductImage);
